import { lazy } from 'react';

const CircularityNominationConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/circularity/consult/nominations',
			component: lazy(() => import('./NominationContainer'))
		}
	]
};

export default CircularityNominationConfig;
